module.exports = __webpack_public_path__ + "img/boydgrc-v-474x632.c4bf9091.jpg";